import { SearchBarWithFiltersViewModel } from 'KM/SearchBarWithFiltersViewModel';


var searchViewModel = new SearchBarWithFiltersViewModel();
searchViewModel.InitSubscribers();


global.searchViewModel = searchViewModel;
